// @ts-strict-ignore
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { LMModel } from '@form/model';
import { LMFieldServiceAdapter } from '@field/lm-field-service-adapter';
import { LMThemeService } from '@banner/lm-theme.service';
import { Observable } from 'rxjs';
import { LMTextBaseComponent } from '@field/text/lm-text-base.component';

enum LMTextTypeDisplayEnum {
  PLAIN = 0,
  MASK,
  PLAIN_FORM_TEXT,
  HTTP_FORM_TEXT,
  DISPLAY_AS_TEXT,
  DISPLAY_AS_TAG
}

@Component({
  selector:    'lm-text-soho',
  standalone: false,
  templateUrl: './lm-text-soho.component.html',
  styleUrls:   [ 'lm-text-soho.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LMTextSohoComponent extends LMTextBaseComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() layoutObject: LMFormLayoutField;
  @Input() specFields: LMSpecFields;
  @Input() model: LMModel;

  @Output() fieldEvent: EventEmitter<LMFieldEvent> = new EventEmitter<LMFieldEvent>();

  @HostBinding('attr.type') isPassword = 'text';

  @HostBinding('attr.data-automation-id') dataFieldAutomationId = '';

  // @HostBinding('attr.aria-describedby') fieldDescriptionId = null;

  @HostBinding('class.lm-form-text-container') hasFormTextChild = false;

  public hasRichTextVars = false;
  public filterSettings: Array<SohoFieldFilterOption>;
  public launchButtonTooltip: string;
  public hasContextMenu$: Observable<boolean>;
  public messageIcon: string = null;
  public iconUrl: string;
  public validSohoIcon: boolean;

  public displayType: LMTextTypeDisplayEnum;
  public layoutDisplayType = LMTextTypeDisplayEnum;

  constructor(
    protected lmFieldServiceAdapter: LMFieldServiceAdapter,
    public elementRef: ElementRef,
    public lmThemeService: LMThemeService
  ) {
    super(lmFieldServiceAdapter, elementRef, lmThemeService);
  }

  // events
  ngOnInit() {
    super.ngOnInit();
    super.initialize(this.layoutObject, this.specFields, this.model);
    this.textInitialize();
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
